// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-divider-horizontal"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8 18L8 6L3 6L3 18H8Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21 18V6L16 6L16 18H21Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M8 18L8 6L3 6L3 18H8Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21 18V6L16 6L16 18H21Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 3L12 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentDividerHorizontalIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-divider-horizontal',
    ref,
    icon: element,
  },
));

ComponentDividerHorizontalIcon.displayName = 'ComponentDividerHorizontalIcon';

export default ComponentDividerHorizontalIcon;
